import { render, staticRenderFns } from "./BankInfos.vue?vue&type=template&id=6f0e7b46&"
import script from "./BankInfos.vue?vue&type=script&lang=js&"
export * from "./BankInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports